import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

import { type ShareModalStateType } from '@vimeo/resource-share-modal';

import { type VideoShareModalSharedType } from '../utils/types';

const VideoShareModal = dynamic(async () => {
  const { VideoShareModal } = await import('@vimeo/video-share-modal');
  return VideoShareModal;
});

export const useShareModalState = (initialState: boolean) => {
  const [shareModalActive, setShareModalActive] = useState(initialState);
  const [shareModalState, setShareModalState] = useState<ShareModalStateType>();

  useEffect(() => {
    if (window.location.hash === '#share') {
      setShareModalState('SHARE');
      setShareModalActive(true);

      return;
    }

    if (window.location.hash === '#embed') {
      setShareModalState('EMBED');
      setShareModalActive(true);

      return;
    }
  }, []);

  return { shareModalState, setShareModalActive, shareModalActive };
};

interface Props {
  /** uri for the location of where share modal is used, e.g. `video/clipId`, used for split out sharing resource type, video or folder */
  uri: string;
  /** toggle for show or hide Share Modal */
  active: boolean;
  /** share modal tab state */
  modalState?: ShareModalStateType;
  /** callback when clicking Share Modal close button */
  onClose: () => void;
  /** callback to trigger the login modal when necessary */
  onLoginRequired: () => void;
  /** shared props for the Share Modal */
  shared: VideoShareModalSharedType;
}

/**
 * Share Modal is owned by Collaboration team
 * `showPrivacyRedesign` prop needs to be true to turn on redesign; legacy share modal doesn't support viewer experience  (without edit permission)
 * `ownerUri` props seems to be already checked within the component
 */
export const ShareModalModule = ({
  uri,
  active,
  modalState,
  onClose,
  onLoginRequired,
  shared = {},
}: Props) => {
  return (
    <VideoShareModal
      uri={uri}
      page={'Viewer Home'}
      entryPoint={null}
      isResourceShareModalOpen={active}
      closeResourceShareModal={onClose}
      showPrivacyRedesign
      onLoginRequired={onLoginRequired}
      shared={shared}
      {...(modalState && { modalState })}
    />
  );
};
